import { render, staticRenderFns } from "./TransitionCollapse.vue?vue&type=template&id=1177c8c1&scoped=true&"
import script from "./TransitionCollapse.vue?vue&type=script&lang=js&"
export * from "./TransitionCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1177c8c1",
  null
  
)

export default component.exports